/**
 * Document Type to Encompass Group Mapping
 *
 * Maps DOCUMENT_TYPES categories to canonical Encompass group names
 * for consistent grouping between Lendwise uploads and Encompass documents.
 */

/**
 * Maps DOCUMENT_TYPES category to exact Encompass group name
 * Note: Encompass uses different naming in some cases:
 * - "Asset" (singular) instead of "Assets"
 * - "Credit Report" instead of "Credit"
 */
export const CATEGORY_TO_ENCOMPASS_GROUP: Record<string, string> = {
  // Direct mappings (same name)
  Appraisal: 'Appraisal',
  AUS: 'AUS',
  Income: 'Income',
  Property: 'Property',
  Title: 'Title',
  Disclosures: 'Disclosures',
  FHA: 'FHA',
  VA: 'VA',

  // Name differences
  Assets: 'Asset',           // Encompass uses singular
  Credit: 'Credit Report',   // Encompass uses full name

  // Other mappings
  Entity: 'Entity Docs',
  ID: 'ID',
  USDA: 'USDA',
  Insurance: 'Insurance',
  Compliance: 'Compliance',

  // Fallback for unknown categories
  Other: 'UW Misc',
  Miscellaneous: 'UW Misc',
  Unknown: 'Unclassified'
};

/**
 * Canonical Encompass groups with sort order
 * Lower number = appears first, 999 = last
 */
export const GROUP_ORDER: Record<string, number> = {
  Income: 1,
  Asset: 2,
  'Credit Report': 3,
  Property: 4,
  Appraisal: 5,
  Title: 6,
  Insurance: 7,
  AUS: 8,
  Disclosures: 9,
  Compliance: 10,
  FHA: 11,
  VA: 12,
  USDA: 13,
  'Entity Docs': 14,
  ID: 15,
  'Mortgage Insurance': 16,
  'Sales Contract/Closing': 17,
  'Rate Lock & Doc Order': 18,
  'Analyzer Docs': 19,
  'Needs List - Initial': 20,
  'UW Misc': 97,
  'Other Documents': 98,
  Unclassified: 99
};

/**
 * Get the Encompass group name for a DOCUMENT_TYPES category
 */
export function getEncompassGroupForCategory(category: string | null | undefined): string {
  if (!category) {
return 'Unclassified';
}
  return CATEGORY_TO_ENCOMPASS_GROUP[category] || 'Unclassified';
}

/**
 * Get the sort order for a group
 */
export function getGroupOrder(groupName: string): number {
  return GROUP_ORDER[groupName] ?? 50; // Default to middle if unknown
}

/**
 * Format group name for display
 * Most Encompass groups are already well-formatted
 */
export function formatGroupDisplayName(groupName: string): string {
  if (!groupName) {
return 'Unclassified';
}
  return groupName;
}
